import React from 'react';

import {pure} from 'recompose';

const Bubble = (props) => (
  <div
    style={{
      position: 'absolute',
      left: (props.avatarRadius-props.radius)/2,
      top: (props.avatarRadius-props.radius)/2,
      zIndex: -1,
      borderRadius: 9999,
      width: props.radius,
      height: props.radius,
      backgroundColor: props.color,
      opacity: .6,
      transition: `all ${props.speed} ease-in-out`
    }}
  />
)

export default pure(Bubble);



// WEBPACK FOOTER //
// ./src/components/Bubble.js